import styled from 'styled-components';

export const LogoScreenStyled = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--color-base-secondary);
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
        width: 25%;
    }
`;
